module.exports = __webpack_public_path__ + "assets/img/logo.27279dca.png";